module.exports = __webpack_public_path__ + "img/13.eecaf34a.jpg";